<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";



/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Deposits",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Customer Deposits ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customers Deposits",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "customer.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode",
          sortable: true,
          label: "MODE",
        },

        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "added_on",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingCustomer: [],
      amountError: "",
      dateError: "",
      customerError: "",
      modeError: "",
      nameError: "",
      contactError: "",

      // Value from user input for adding a deposit
      data: {
        customer: "",
        amount: "",
        mode: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        filterdata: {}
      },
      // edit unit
      editdata: {
        date: "",
        amount: "",
        id: "",
        filterdata: {}
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
        filterdata: {}
      },

      filterdata: {
        customer: "",
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
      total_amount: 0
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["SaveStatus", "Customers", "CustomerDeposits","filterStatus"]),
    ...mapGetters("setting", ["PaymentOptions", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapState("customers", ["depositId"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CustomerDeposits ? this.CustomerDeposits.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerDeposits ? this.CustomerDeposits.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCustomerDeposits: "customers/fetchCustomerDepositReport",
      FetchCustomers: "customers/fetchCustomers",
      FetchPaymentOptions: "setting/fetchPaymentOptions",
      AddCustomerDeposit: "customers/addCustomerDeposit",
      EditCustomerDeposit: "customers/editCustomerDeposit",
      DeleteCustomerDeposit: "customers/deleteCustomerDeposit",
      AddCustomer: "customers/addCustomer",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCustomerDeposit(modalId) {
      this.modal_id = modalId;
      this.data.amount = this.data.amount.replaceAll(/,/g, '');
      if (this.data.date === "") {
        this.dateError = "Date  field is required";
        return;
      } else {
        this.dateError = "";
      }
      if (this.data.date > moment(new Date()).format("YYYY-MM-DD")) {
        this.dateError = "Dat cannot be greater than today";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.customer === "") {
        this.customerError = "Customer  field is required";
        return;
      } else {
        this.customerError = "";
      }

      if (this.data.amount === "") {
        this.amountError = "Amount field is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.mode === "") {
        this.modeError = "Payment Mode field is required";
        return;
      } else {
        this.modeError = "";
      }
      this.data.filterdata = this.filterdata;
      this.AddCustomerDeposit(this.data);
    },

    resetAdd() {
      this.data.customer = "";
      this.data.amount = "";
      this.data.mode = "";
      this.modal_id = "";
    },

    resetEdit() {
      this.editdata.date = "";
      this.editdata.amount = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.customerError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.nameError = "";
      this.contactError = "";
    },
    showEditModal(val) {
      this.editdata.amount = val.item.amount;
      this.editdata.date = val.item.date;
      this.editdata.id = val.item.id;
    },
    editCustomerDeposit(modalId) {
      this.modal_id = modalId;
      if ((this.editdata.amount < 0) || (this.editdata.amount == "")) {
        this.amountError = "Amount should be greater than 0";
        return;
      } else {
        this.amountError = "";
      }
      if (this.editdata.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      this.editdata.filterdata = this.filterdata;
      this.EditCustomerDeposit(this.editdata);
    },
    validateCustomerEdit() {
      if (this.editdata.name != "" && this.editdata.contact != '') {
        let selCust = this.Customers.filter((item) => {
          return (item.phone == parseInt(this.editdata.contact)) && (item.id != this.editdata.id);
        })
        let custCount = selCust.length;
        if (custCount > 0) {
          this.customerError = "Customer with contact " + this.editdata.contact + "  already Exists";
        }
      }

    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.amount;
      this.deletedata.id = val.item.id;
    },
    deleteCustomerDeposit(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterdata;
      this.DeleteCustomerDeposit(this.deletedata);
    },

    AddCommas() {
      this.data.amount = this.thousandSeprator(this.data.amount)
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.data.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    filterReport() {
      this.FetchCustomerDeposits(this.filterdata);
    }
  },
  updated() {
    let total_amount = 0;
    if (this.CustomerDeposits) {
      this.CustomerDeposits.forEach((item) => {
        total_amount = total_amount + parseInt(item.amount);
      });
      this.total_amount = total_amount;
    }
  },
  created() {
    this.FetchCustomerDeposits(this.filterdata);
    this.FetchCustomers();
    this.FetchPaymentOptions();
    this.setDefaultMode();
    this.fetchReceiptSettings();

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Customer Deposits</h4>
              </div>
              <div v-if="MyUserPerm.add_customer_deposits == 1 && BranchData.BranchId != 0" class="col-md-3"
                align="right">
                <b-button v-b-modal.add-product-modal
                  style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"><i
                    class="fa fa-plus"></i> Add New Deposit</b-button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-md-4 mb-3">
                <label>Filter By Customer <span class="text-danger">*</span></label>
                <model-list-select
                    :list="Customers ? Customers : []"
                    v-model="filterdata.customer"
                    option-value="id"
                    option-text="name"
                    placeholder="Select customer"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="filterdata.datefrom" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="filterdata.dateto" class="form-control" />
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn"
                  style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                  type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="CustomerDeposits ? CustomerDeposits : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(amount)="data">
                  {{ (data.item.amount).toLocaleString() }}
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="MyUserPerm.edit_customer_deposits == 1" size="sm"
                    style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                    v-b-modal.edit-product-modal class="m-2" @click="showEditModal(data)"><i
                      class="fa fa-edit"></i></b-button>
                  <b-button v-if="MyUserPerm.delete_customer_deposits == 1" size="sm" variant="danger"
                    v-b-modal.delete-product-modal @click="showDeleteModal(data)"><i class="fa fa-trash"></i></b-button>
                </template>
              </b-table>
              <div class="row text-center">
                <h5>Total Amount: <span class="text-danger">{{ (total_amount).toLocaleString() }}</span></h5>
              </div>
            </div>
            <Loader v-if="!CustomerDeposits" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal starts -->
    <b-modal id="add-product-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer deposit </template>
      <div class="form-group mb-3">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="date" placeholder="Enter date " class="form-control" v-model="data.date" max=""
            @input="resetError()" />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Select Customer <span class="text-danger">*</span></label>
        <model-list-select :list="Customers ? Customers : []" v-model="data.customer" option-value="id"
          option-text="name" class="mb-3" placeholder="Select customer" @input="resetError()">
        </model-list-select>

        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>


      <div class="form-group mb-3">
        <label>Amount <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Amount " class="form-control" @input="AddCommas(), resetError()"
            v-model="data.amount" />
        </div>
        <div class="text-danger" v-if="amountError">
          <em>{{ amountError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Mode <span class="text-danger">*</span></label>
        <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="data.mode" option-value="id"
          option-text="mode" class="mb-3" placeholder="Select mode" @input="resetError()">
        </model-list-select>
        <div class="text-danger" v-if="modeError">
          <em>{{ modeError }}</em>
        </div>

      </div>



      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-product-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button"
          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
          class="btn" disabled> <i class="fa fa-check"></i>
          Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn"
          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
          @click="addCustomerDeposit('add-product-modal')"> <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--     edit modal starts-->
    <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Customer deposit of {{ editdata.amount }}</template>
      <div class="form-group mb-3">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="date" class="form-control" @input="resetError()" v-model="editdata.date" />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Amount <span class="text-danger">*</span></label>
        <input type="number" class="form-control" @input="resetError()" v-model="editdata.amount" />

        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('edit-product-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn"
          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
          disabled>
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner variant="light" small label="Saving"></b-spinner>
        </button>
        <button v-else type="button" class="btn"
          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
          @click="editCustomerDeposit('edit-product-modal')"> <i class="fa fa-check"></i>
          Save Changes
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
      footer-bg-variant="danger" footer-text-variant="danger" id="delete-product-modal" hide-footer
      @hidden="resetDelete">
      <template #modal-title> Delete Customer deposit of {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          @click="closeModal('delete-product-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteCustomerDeposit('delete-product-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}

.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
